<section class="create-new-alert-dialog">
  <div mat-dialog-title class="dialog-header">
    <span class="title">Create New Alert</span>
    <button
      mat-icon-button
      mat-dialog-close
      class="material-icons floatRight close-btn"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <mat-dialog-content class="dialog-content">
    <div class="left-side">
      <mat-vertical-stepper #stepper class="stepper">
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
        @for (label of STEP_LABELS; track label) {
        <mat-step [label]="label"></mat-step>
        }
      </mat-vertical-stepper>
    </div>
    <div class="right-side">
      @if (currentStepIndex === 0) {
      <div>
        <app-add-watch-order
          [orders$]="this.orders$"
          [showHeader]="true"
        ></app-add-watch-order>
      </div>
      } @if (currentStepIndex === 1) {
      <div>
        <app-alert-settings #alertSettings></app-alert-settings>
      </div>
      } @if (currentStepIndex === 2) {
      <div>
        <app-adjust-hit-overview
          [columns]="columns"
          #adjustHitOverview
        ></app-adjust-hit-overview>
      </div>
      }
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions class="dialog-actions">
    <button
      id="prevActionBtn"
      mat-stroked-button
      color="primary"
      [class.hidden]="currentStepIndex === 0"
      (click)="goToPrevStep()"
    >
      <mat-icon>arrow_backward</mat-icon>
      @if (currentStepIndex !== 0) {
      <span>{{ this.ACTION_BUTTON_LABELS[this.currentStepIndex - 1] }}</span>
      }
    </button>
    <button
      [id]="
        stepper.selectedIndex === 2 ? 'create-watch-alert-btn' : 'nextActionBtn'
      "
      mat-flat-button
      color="primary"
      [disabled]="isDisabled()"
      (click)="currentStepIndex === 2 ? onCreateAlert() : goToNextStep()"
    >
      <span>{{ this.ACTION_BUTTON_LABELS[this.currentStepIndex + 1] }}</span>
      @if (this.currentStepIndex !== 2) {
      <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      }
    </button>
  </mat-dialog-actions>
</section>
